import React from 'react';
import {
  lotAvailabilityMeta,
  type LotAvailabilityStatusId,
} from '../../utils/lotAvailabilityStatus';

type LotAvailabilityBadgeProps = {
  status: LotAvailabilityStatusId;
};

const LotAvailabilityBadge: React.FC<LotAvailabilityBadgeProps> = ({ status }) => {
  const meta = lotAvailabilityMeta(status);
  return (
    <span
      className={`inline-flex items-center px-2.5 py-1 rounded-full text-xs font-semibold whitespace-nowrap ${meta.badgeClass}`}
    >
      {meta.label}
    </span>
  );
};

export default LotAvailabilityBadge;
